import api from './api';

export const getCompanySettings = () => api.get('/v1/company-settings');
export const updateCompanySettings = (data) => api.put('/v1/company-settings', data);
